import { ZyNodeViewWrapper } from '@/components/common/node-view-wrapper';
import { NodeViewContent } from '@tiptap/react';

export function ZyFctNameInlineNodeView() {
    return (
        <ZyNodeViewWrapper
            as="span"
            className="inline-flex items-center rounded-md border border-teal-300/80 bg-teal-50/70 px-1 py-0.5 align-middle dark:border-teal-700/80 dark:bg-teal-900/30"
            data-zy-fctname-inline
        >
            <NodeViewContent<'span'>
                as="span"
                className="inline-flex items-center gap-1"
            />
        </ZyNodeViewWrapper>
    );
}
